 
<template>
<!-- // 弃用 -->
    <div   class="og-calendar"   >

        <div class="header">
            <div class="btn month-pre" bindtap="changeDateEvent" :data-year="data.beforeYear" :data-month="data.beforMonth"> 
                <image src="https://11law.lawtip.cn/images/left-move.png"></image>
            </div>
            <div class="date-info">
                <!-- <picker mode="date"  value="{{pickerDateValue}}" bindchange="datePickerChangeEvent" start='2000/09/01' end='2030/09/01'> 
                <span>{{data.showYear}}年{{data.showMonth > 9 ? data.showMonth : ('0' + data.showMonth)}}月</span>
                </picker> -->
            </div> 
            <div class="btn month-next" bindtap="changeDateEvent" :data-year="data.afterYear" :data-month="data.afterMonth">
                <!-- <image src="../../images/nextpage2.png"></image> -->
                <image src="https://11law.lawtip.cn/images/right-move.png"></image>

            </div>
        </div>

        <div class="week row">

        <div class="col">
            <span>一</span>
        </div>
        <div class="col">
            <span>二</span>
        </div>
        <div class="col">
            <span>三</span>
        </div>
        <div class="col">
            <span>四</span>
        </div>
        <div class="col">
            <span>五</span>
        </div>
        <div class="col">
            <span>六</span>
        </div>
        <div class="col">
            <span>日</span>
        </div>
        </div>

        <div class="body row">  
            <!-- v-for="(item,index) of resultList" v-bind:key="item._id" -->
        <div v-for="(item,index) of  data.dates"  v-bind:key="index"   >
            
            <div bindtap="dateClickEvent" :data-year="item.year" :data-month="item.month" :data-date="item.date"       >
                 <!-- class="col {{data.showMonth == item.month ? '' : 'old'}} {{data.currentDate == item.date && data.currentYear==item.year && data.currentMonth == item.month ? 'current' : ''}} {{item.active ? 'active' : ''}}  {{item.mark ? 'mark' : ''}} "   -->
            
                <span :style="item.iscourt?'background-image:url(https://11law.lawtip.cn/images/courtjudge_35.png);background-size:contain; ':''" >{{item.date}}</span>
            

            </div> 
        
        </div>
        </div>
    </div>


</template>

<script>
    export default {
		name:'Calendar',
		props: {
		 
		},
		methods: {
			// handleSizeChange(val) {
			// 	console.log('每页 ${val} 条');
			// },
			handleCurrentChange(val) {
				window.console.log('当前页:',val);
				this.$emit('ChangePage',val);  
			}
		},
		data() {
			return {
				data: {},
			};
		}
	}



</script>

<style>
</style>
